import _ from 'lodash';

export const getCheckpoints = (submissions: any[], checkpoints: any[]) => {
    let values = {
        total: 0,
        sum: 0,
    };

    const groupedSubmissions = _.groupBy(submissions, 'uoa_id');

    Object
        .values(groupedSubmissions)
        .forEach((submissions) => {
            const dates: string[] = [];

            submissions.forEach(submission => {
                const checkpoint = checkpoints.find(({id}) => id === submission.checkpoint_id);

                if (checkpoint) {
                    dates.push(checkpoint.start_at)
                }
            });

            if (dates.length > 0) {
                const dateObjects = dates.map(date => new Date(date));

                const minDate = new Date(Math.min(...dateObjects.map(date => date.getTime())));
                const maxDate = new Date(Math.max(...dateObjects.map(date => date.getTime())));

                const monthDiff = (maxDate.getFullYear() - minDate.getFullYear()) * 12 + (maxDate.getMonth() - minDate.getMonth());

                values.total++;
                values.sum += monthDiff;
            }
        })


    if (values.total > 0) {
        return Number((values.sum / values.total).toFixed(2));
    }

    return 0;
}